import useStyles from './Media.styled'

export const useMedia = props => {
	const { align, shading, objectFit, className, isBackground, metaData, autoplay } = props
	const classes = useStyles(props)

	return [
		{
			key: metaData?.image,
			classes,
			className,
			align,
			shading,
			objectFit,
			isBackground,
			metaData,
			autoplay,
		},
	]
}
